import React from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import theme from '../../theme';
import PowerPlugIcon from '@mui/icons-material/Power';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';

const STEPS = [
  {
    Icon: PowerPlugIcon,
    title: 'Connect any source',
    body: 'Snowflake, BigQuery, Redshift, Postgres, or whatever else feeds your stack — no migration required.',
  },
  {
    Icon: LockOpenIcon,
    title: 'Skip the internal queue',
    body: 'We work directly with your data, so a stretched internal team is never the reason a report is late.',
  },
  {
    Icon: DesktopWindowsIcon,
    title: 'Ship where it belongs',
    body: 'Embed in Tableau, Power BI, or Looker, or get a custom front end built from scratch.',
  },
];

export default function BusinessIntelligenceHowItWorks() {
  const { width } = useWindowDimensions();
  const isCompact = width < 700;

  return (
    <View
      style={{
        paddingHorizontal: isCompact ? theme.spacing.space5 : theme.spacing.space12,
        paddingVertical: isCompact ? theme.spacing.space10 : theme.spacing.space16 + 6,
        maxWidth: 1240,
        alignSelf: 'center',
        width: '100%',
        borderTopWidth: theme.borderWidth.thin,
        borderTopColor: theme.colors.borderSubtle,
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: isCompact ? theme.typography.size.lg : theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          color: theme.colors.textPrimary,
          textAlign: 'center',
          marginBottom: theme.spacing.space10,
        }}
      >
        How it works
      </Text>

      <View style={{ flexDirection: isCompact ? 'column' : 'row', gap: theme.spacing.space8 }}>
        {STEPS.map((step, i) => {
          const Icon = step.Icon;
          return (
            <View key={i} style={{ flex: isCompact ? undefined : 1, alignItems: 'center' }}>
              <View
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: theme.radii.lg,
                  backgroundColor: theme.colors.surfaceSunken,
                  borderWidth: theme.borderWidth.thin,
                  borderColor: theme.colors.borderDefault,
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: theme.spacing.space4,
                }}
              >
                <Icon style={{ fontSize: 22, color: theme.colors.accentPrimary }} />
              </View>
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontWeight: theme.typography.weight.semibold,
                  fontSize: theme.typography.size.md,
                  color: theme.colors.textPrimary,
                  textAlign: 'center',
                  marginBottom: theme.spacing.space2,
                }}
              >
                {step.title}
              </Text>
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontSize: theme.typography.size.sm,
                  color: theme.colors.textSecondary,
                  lineHeight: theme.lineHeightPx(theme.typography.size.sm, 'normal'),
                  textAlign: 'center',
                  maxWidth: 280,
                }}
              >
                {step.body}
              </Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}
